import React, { useState, useEffect, useRef } from 'react'
import styles from './Filter.module.scss'
import Select,{ components } from 'react-select'
import DropDownList from '../../components/DropDownList'
import { useGeoState,useGeoFetch } from '../../components/GeoProvider'
import getVectorImage from '../../utils/getVectorImage'
const FilterData=({getComorbFilter,regionDisplayOptions})=>{
    const {
    regionSelected,
    setRegionSelected,
    getComorbState,
    setComorbState,
    getAgeState,
    setAgeState,
    getTrimesterState,
    setTrimesterState,
  } = useGeoState()
    let ageBucketOptions=[]
    let comorbOptions=[]
    let compliOptions=[]
    let trimesterOptions=[]
   const colourStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: 'white',
      borderRadius: '4px',
      border: '1px solid #4B4D4F',
      boxSizing: 'border-box',
      cursor: 'pointer',
    }),
    option: (base, state) => ({
      ...base,
      color: '#1e2022',
      backgroundColor: 'white',
      padding: '.5rem 3rem .5rem .5rem',
      cursor: 'pointer',
      fontWeight: state.isSelected ? 'bold' : '',
    }),
    multiValue: (styles, { data }) => {
      return {
        ...styles,
        backgroundColor: '#002677',
        color: 'white',
        borderRadius: '100px',
        cursor: 'pointer',
        padding: '0px 0px 0px 5px',
      }
    },
    multiValueLabel: (styles, { data }) => ({
      ...styles,
      color: 'white',
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1
      const transition = 'opacity 300ms'

      return { ...provided, opacity, transition }
    },
    multiValueRemove: (styles, { data }) => ({
      ...styles,
      color: 'white',
      backgroundColor: '#002677',
      borderRadius: '100px',
      width: '32px',

      '&:hover': {
        backgroundColor: '#002677',
        color: 'white',
        borderRadius: '100px',
      },
    }),
    groupHeading: (provided) => ({
    ...provided,
    fontWeight: 'bold',
    fontSize: '14px',
    padding: '5px 10px',
    color:'black'
  }),
  valueContainer: (provided) => ({
    ...provided,
    maxHeight: 60, // or whatever height is appropriate
    overflowY: 'auto',
    flexWrap: 'wrap', // ensures tags wrap to new lines
    display: 'flex'
  }),
  }
    const changeHandlerComorb = (e) => {
    setComorbOptions(e)
  };
 const formatGroupLabel = (data) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }} tabIndex={-1} >
    <span>{data.label}</span>
    {/* <Tooltip title={`More info about ${data.label}`} placement="right">
      <AiOutlineInfoCircle title={`Info about ${data.label}`} style={{ cursor: 'pointer', color: '#007bff' }} />
    </Tooltip> */}
  </div>

)


  
 const groupedOptions = [
  {
    label: 'Comorbidity',
    options: comorbOptions
  },
  {
    label: 'Complications',
    options: compliOptions
  }
]
    getComorbFilter.map((state) => {
      let obj={value:state.data_id.toString(),label:state.display_value}
      if(state.category_name==="COMORBIDITY")
      {
        comorbOptions.push(obj)
      }
      else if(state.category_name==="COMPLICATION")
      {
        compliOptions.push(obj)
      }
      else if(state.category_name==="AGEGENDER")
      {
        ageBucketOptions.push(obj)
      }
      else if(state.category_name==="TRIMESTER")
      {
        trimesterOptions.push(obj)
      }
    })
  // Custom Option component with checkbox
const CheckboxOption = (props) => {
}
const RadioButtonOption = (props) => {
}
const CustomMenuList = (props) => {
};
 const [selectedAgeOptions, setSelectedAgeOptions] = useState(getAgeState)
  const [selectedTrimesterOptions, setSelectedTrimesterOptions] = useState(getTrimesterState)
  const [getComorbOptions, setComorbOptions] = useState(getComorbState)
   const [searchCriteria, setSearchCriteria] = useState([])

   const onApplyComorb = () => {
      setComorbState(getComorbOptions)
  };
 
  const onClearComorb = () => {
    setComorbOptions([])
    setComorbState([])
  };

  function changeHandlerAge(e) {
    setSelectedAgeOptions(e)
    setAgeState(e)
  }
  function changeHandlerTrimester(e) {
    setSelectedTrimesterOptions(e)
    setTrimesterState(e)

  }
  console.log(ageBucketOptions)
  console.log(trimesterOptions)
    return ( 
    <div className={`${styles.base}`}>
        <div className={styles.filter1Panel}>
             <p>Area </p>
          <DropDownList
          id="regions"
          name="regions"
          // styles={colourStyles}
          onChange={(e) => {
            // history.push({ hash: null })
            setRegionSelected(e.target.value)
          }}
          className={styles.dropDowns}
          defaultValue={regionSelected}
        >
          {regionDisplayOptions.map((regions, regionsIndex) => {
            return (
              <DropDownList.Item
                value={regions.value}
                key={regions.value}
                selected={regionSelected === regions.value}
              >
                {regions.label}
              </DropDownList.Item>
            )
          })}
        </DropDownList>
        </div>
        <div className={styles.filter2Panel}>
              <p>Disease Model</p>
                <DropDownList
          id="disease"
          name="disease"
          // styles={colourStyles}
          onChange={(e) => {
            // history.push({ hash: null })
            // setRegionSelected(e.target.value)
          }}
          className={styles.dropDowns}
          defaultValue={regionSelected}
        >
          {ageBucketOptions.map((regions, regionsIndex) => {
            return (
              <DropDownList.Item
                value={regions.value}
                key={regions.value}
                selected={regionSelected === regions.value}
              >
                {regions.label}
              </DropDownList.Item>
            )
          })}
        </DropDownList>

        </div>
        <div className={styles.filter3Panel}>
              <p>Datasets </p>
               <DropDownList
          id="disease"
          name="disease"
          // styles={colourStyles}
          onChange={(e) => {
            // history.push({ hash: null })
            // setRegionSelected(e.target.value)
          }}
          className={styles.dropDowns}
          defaultValue={regionSelected}
        >
          {trimesterOptions.map((regions, regionsIndex) => {
            return (
              <DropDownList.Item
                value={regions.value}
                key={regions.value}
                selected={regionSelected === regions.value}
              >
                {regions.label}
              </DropDownList.Item>
            )
          })}
        </DropDownList>
      
        </div>
        <div className={styles.filter4Panel}>
              <button
              className={styles.buttonClass}
              onClick={() => {
                // handleClick()
              }}
            >
              {getVectorImage('export', '16px', '16px')}
              Export
            </button>
             
        </div>
    </div>)
}
const Filter = () => {
      let comorbFilterOptions = [
    {
        "data_id": 0,
        "data_value": "All",
        "display_value": "All",
        "category_name": "AGEGENDER",
        "primary_disease": "PRENATAL"
    },
    {
        "data_id": 1,
        "data_value": "10-17",
        "display_value": "10-17",
        "category_name": "AGEGENDER",
        "primary_disease": "PRENATAL"
    },
    {
        "data_id": 2,
        "data_value": "18-24",
        "display_value": "18-24",
        "category_name": "AGEGENDER",
        "primary_disease": "PRENATAL"
    },
    {
        "data_id": 3,
        "data_value": "25-34",
        "display_value": "25-34",
        "category_name": "AGEGENDER",
        "primary_disease": "PRENATAL"
    },
    {
        "data_id": 4,
        "data_value": "35-44",
        "display_value": "35-44",
        "category_name": "AGEGENDER",
        "primary_disease": "PRENATAL"
    },
    {
        "data_id": 5,
        "data_value": "45-60",
        "display_value": "45-60",
        "category_name": "AGEGENDER",
        "primary_disease": "PRENATAL"
    },
    {
        "data_id": 1,
        "data_value": "First",
        "display_value": "First",
        "category_name": "TRIMESTER",
        "primary_disease": "PRENATAL"
    },
    {
        "data_id": 2,
        "data_value": "Second",
        "display_value": "Second",
        "category_name": "TRIMESTER",
        "primary_disease": "PRENATAL"
    },
    {
        "data_id": 3,
        "data_value": "Third",
        "display_value": "Third",
        "category_name": "TRIMESTER",
        "primary_disease": "PRENATAL"
    },
    {
        "data_id": 1,
        "data_value": "Comorbidity Asthma",
        "display_value": "Asthma",
        "category_name": "COMORBIDITY",
        "primary_disease": "PRENATAL"
    },
    {
        "data_id": 2,
        "data_value": "Comorbidity Lipid Metabolism Disorders",
        "display_value": "Lipid Metabolism Disorders",
        "category_name": "COMORBIDITY",
        "primary_disease": "PRENATAL"
    },
    {
        "data_id": 3,
        "data_value": "Comorbidity Hypertension",
        "display_value": "Hypertension",
        "category_name": "COMORBIDITY",
        "primary_disease": "PRENATAL"
    },
    {
        "data_id": 4,
        "data_value": "Complication Hyperemesis Gravidarum",
        "display_value": "Hyperemesis Gravidarum",
        "category_name": "COMPLICATION",
        "primary_disease": "PRENATAL"
    },
    {
        "data_id": 5,
        "data_value": "Complication Asthma",
        "display_value": "Asthma",
        "category_name": "COMPLICATION",
        "primary_disease": "PRENATAL"
    },
    {
        "data_id": 6,
        "data_value": "Complication Hypertensive Conditions",
        "display_value": "Hypertensive Conditions",
        "category_name": "COMPLICATION",
        "primary_disease": "PRENATAL"
    }
  ]
    let regionDisplayOptions = [
    {
        "value": "state",
        "label": "States"
    },
    {
        "value": "zip3",
        "label": "States + ZIP3"
    }
    ]
const [getComorbFilter, setComorbFilter] = useState()
 const { data: activeCbsasData, error: activeCbsasDataError } = useGeoFetch(
    '',
    '',
    'utiactivelocations',
    '',
    false,
    {disease_type:'UTI',geo_type:'MSA',geo_parent_code:'NA'} 
  )
   useEffect(() => {
      if (activeCbsasData !== null && activeCbsasData !== undefined) {
        
        setComorbFilter(comorbFilterOptions)
      }
    }, [activeCbsasData])
//  useEffect(() => {
//       fetch(
//           `${process.env.REACT_APP_BACKEND_BASE_URL}/birthtrend/staticdata`,
//           {
//             method: 'post',
//             headers: {
//               'Content-Type': 'application/json',
//               requester: JSON.stringify(window.localStorage.getItem('requester')),
//             },
//             body: JSON.stringify({
//               table_type:'COMORBIDITY',
//               category_ids:'1'
//             }),
//             withCredentials: true,
//             credentials: 'include',
//           }
//         )
//           .then((response) => response.json())
//           .then((resData)=>{
//             if (resData !== null && resData !== undefined) {
//               if (resData.status === 200) {
//                 setComorbFilter(comorbFilterOptions)
//               }
//             }
//           })},[1])

    return (
        <>
        {getComorbFilter!==undefined&&
            <FilterData getComorbFilter={getComorbFilter}
            regionDisplayOptions={regionDisplayOptions}/>
            }
        </>
    )

}
export default Filter